// react
import { useEffect, useState } from 'react';

// types
import { LoadingStatus } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormAddTransfer } from '../../forms/FormAddTransfer/FormAddTransfer';

// props
export interface DialogAddTransferProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddTransfer = ({ isOpen, onClose, onSuccess }: DialogAddTransferProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [status, setStatus] = useState<LoadingStatus>('DEFAULT');

	const DialogActionsProps: Partial<DialogActionsProps> = {};

	if (['DEFAULT', 'ERROR'].includes(status)) {
		DialogActionsProps.actions = [
			{
				children: t('cancel'),
				onClick: onClose,
			},
			{
				children: t('recordFundTransfer'),
				form: 'form-record-transfer',
				loading: status === 'LOADING',
				type: 'submit',
				variant: 'contained',
			},
		];
	}

	if (status === 'SUCCESS') {
		DialogActionsProps.actions = [
			{
				children: t('done'),
				onClick: onClose,
				variant: 'contained',
			},
		];
	}

	// reset status when dialog is closed
	useEffect(() => {
		if (!isOpen) {
			setStatus('DEFAULT');
		}
	}, [isOpen]);

	return (
		<DialogActions
			hasClose={true}
			isOpen={isOpen}
			maxWidth={600}
			onClose={onClose}
			title={{
				children: t('recordFundTransfer'),
				variant: 'h3',
			}}
			{...DialogActionsProps}>
			<FormAddTransfer onSuccess={onSuccess} setStatus={setStatus} status={status} />
		</DialogActions>
	);
};
